export default __webpack_public_path__ + "media/article-group.c5278052.png";